import { IClient } from "../slice/listClientSlice/listClientSlice";
import { api } from "./apiCore";

interface IClientArchive {
  client_id: number;
  is_enabled: boolean;
}

interface AgentBankChronology {
  bank_id: number;
  start_date: string;
  excess_agent: number;
  commission_agent_rate: number;
}

interface IApiClientRequest {
  user: {
    id?: number;
    surname?: string;
    name?: string;
    patronymic?: string;
    email?: string;
    inn?: string | number;
    phone_number?: string;
  };
  organization: {
    inn?: string | number;
    ogrn?: string;
    name?: string;
    phone_number?: string;
    email?: string;
    snils?: string;
  } | null;
}

export const listClientApi = api.injectEndpoints({
  endpoints: (builder) => ({
    //архивировать
    archiveClient: builder.mutation<IClientArchive, IClientArchive>({
      query: (value) => ({
        url: `/auth/user/${value.client_id}/enable`,
        method: "PATCH",
        body: {
          is_enabled: value.is_enabled,
        },
      }),
    }),
    editClient: builder.mutation<IClient, IApiClientRequest>({
      query: (value) => ({
        url: `/auth/user/${value.user.id}`,
        method: "PUT",
        body: {
          user: {
            surname: value.user.surname,
            name: value.user.name,
            patronymic: value.user.patronymic,
            email: value.user.email,
            inn: value.user.inn,
            phone_number: value.user.phone_number,
          },
          organization: {
            inn: value.organization?.inn,
            ogrn: value.organization?.ogrn,
            name: value.organization?.name,
            phone_number: value.organization?.phone_number,
            email: value.organization?.email,
            snils: value.organization?.snils,
          },
        },
      }),
      transformResponse: (response: { data: IClient }) => response.data,
    }),
    //добавить банк в список индивидуального вознаграждения

    addBankToRewardList: builder.mutation<
      [],
      { chronology: AgentBankChronology; agent_id: number }
    >({
      query: (value) => ({
        url: `/auth/admin/create-agent-chronology/${value.agent_id}`,
        method: "PUT",
        body: value.chronology,
      }),
    }),
  }),
});

export const { useArchiveClientMutation, useEditClientMutation } =
  listClientApi;
